import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ui-theme-switch" }
const _hoisted_2 = ["aria-label", "title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "ui-icon-btn ui-theme-toggle",
      id: "switch-toggle",
      type: "button",
      "aria-label": _ctx.isDarkMode ? _ctx.$t('theme.enableLight') : _ctx.$t('theme.enableDark'),
      title: _ctx.isDarkMode ? _ctx.$t('theme.light') : _ctx.$t('theme.dark'),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleDarkMode && _ctx.toggleDarkMode(...args)))
    }, [
      _createElementVNode("i", {
        class: _normalizeClass(_ctx.isDarkMode ? 'ph ph-sun' : 'ph ph-moon'),
        "aria-hidden": "true"
      }, null, 2)
    ], 8, _hoisted_2)
  ]))
}